import React, { useMemo } from 'react';
import { Table } from 'antd';
import styled from 'styled-components';
import CustomEmptyDescription from 'components/CustomEmptyDescription';

const TableContainer = styled.div`

  .ant-table {
    .ant-table-container {
      border: 1px solid #f0f0f0;
      border-radius: 8px;
      overflow: auto;
    }

    .ant-table-content {
      overflow: auto;
    }

    .ant-table-thead > tr > th {
      background: #fafafa;
      font-weight: 600;
      white-space: nowrap;
    }

    .ant-table-tbody > tr > td {
      transition: background 0.3s;
    }

    .ant-table-tbody > tr.ant-table-row:hover > td {
      background: #f5f5f5;
    }

    .sticky-column {
      position: sticky;
      z-index: 1;
      background: white;
    }

    .sticky-left {
      left: 0;
      box-shadow: 6px 0 8px -4px rgba(0, 0, 0, 0.08);
    }

    .sticky-right {
      right: 0;
      box-shadow: -6px 0 8px -4px rgba(0, 0, 0, 0.08);
    }
  }

  /* Ensure table header stays above content when scrolling */
  .ant-table-sticky-holder {
    z-index: 1 !important;
  }

  /* Fix for sticky columns */
  .sticky-column {
    z-index: 1 !important;
  }

  /* Fix for DatePicker and other dropdowns - must be higher than header */
  .ant-picker-dropdown,
  .ant-select-dropdown,
  .ant-dropdown,
  .ant-tooltip,
  .ant-popover {
    z-index: 1050 !important;
  }

  /* Ensure DatePicker panel appears above all other elements */
  .ant-picker-panel-container {
    z-index: 1051 !important;
  }
`;

const CustomTable = ({
  columns = [],
  dataSource = [],
  loading = false,
  scrollX = 'max-content',
  scrollY,
  sticky,
  rowKey = 'id',
  ...rest
}) => {
  // Process columns to add sticky classes and handle width
  const processedColumns = useMemo(() => {
    return columns.map((col) => {
      const column = { ...col };
      const stickyClass = [];

      if (column.fixed === 'left')
        stickyClass.push('sticky-column', 'sticky-left');
      if (column.fixed === 'right')
        stickyClass.push('sticky-column', 'sticky-right');

      // Set default width and minWidth for all columns
      const columnWidth = column.width || 'max-content';
      const minColumnWidth = column.width || '100px'; // Default minimum width for columns without explicit width

      return {
        ...column,
        width: columnWidth,
        onHeaderCell: () => ({
          className: stickyClass.join(' '),
          style: { minWidth: minColumnWidth },
        }),
        onCell: () => ({
          className: stickyClass.join(' '),
          style: { minWidth: minColumnWidth },
        }),
      };
    });
  }, [columns]);

  // Calculate scroll configuration
  const scrollConfig = useMemo(() => {
    const config = {};
    if (scrollX) config.x = scrollX;
    if (scrollY) config.y = scrollY;
    return config;
  }, [scrollX, scrollY]);

  return (
    <TableContainer>
      <Table
        columns={processedColumns}
        dataSource={dataSource}
        loading={loading}
        scroll={scrollConfig}
        sticky={sticky}
        rowKey={rowKey}
        pagination={false}
        locale={{
          emptyText: <CustomEmptyDescription />,
        }}
        {...rest}
      />
    </TableContainer>
  );
};

export default CustomTable;
